import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = {
  key: 0,
  class: "hero-section"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "hero-slider-text" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "three-blocks-section" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "three_block__in" }
const _hoisted_11 = { class: "t_b_txt" }
const _hoisted_12 = { class: "page_link" }
const _hoisted_13 = { class: "four-block-section" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "f_txt" }
const _hoisted_19 = {
  key: 1,
  class: "four-block-content",
  style: {"display":"block"}
}
const _hoisted_20 = { class: "container clearfix b-f-left" }
const _hoisted_21 = { class: "big-picture" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "picture-content showcontent" }
const _hoisted_24 = { class: "four-fold-txt-box" }
const _hoisted_25 = { class: "b_p_txt" }
const _hoisted_26 = {
  key: 0,
  class: "page_link"
}
const _hoisted_27 = { class: "container clearfix b-f-right" }
const _hoisted_28 = { class: "big-picture" }
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  class: "picture-content showcontent",
  id: "readMoewaa"
}
const _hoisted_31 = { class: "home-fold-txt-box" }
const _hoisted_32 = { class: "b_p_txt" }
const _hoisted_33 = {
  key: 0,
  class: "page_link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_userFooter = _resolveComponent("userFooter")!
  const _component_ChatbotPopup = _resolveComponent("ChatbotPopup")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      (_ctx.banners.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (slider) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "carousel-item",
                key: slider.id
              }, [
                _createElementVNode("img", {
                  src: _ctx.getCdnImageAddress(slider.bannerImage, `w_1600,h_500/`),
                  alt: "Banner image"
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "h_s_t_in",
                    innerHTML: slider.title
                  }, null, 8, _hoisted_6)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-sm-4",
                key: article.slug
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.getTruncatedText(article.title, 22)), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.useStripHtml(_ctx.getTruncatedText(article.description, 150))), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: `/article/${article.slug}`,
                      id: "readMoewLink"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.constants['READ_MORE_LINK']), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-sm-3",
                key: service.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["four_block__in", { active: _ctx.selectedServiceId === service.id }]),
                  onClick: ($event: any) => (_ctx.showServiceDetails(service))
                }, [
                  _createElementVNode("i", null, [
                    _createElementVNode("img", {
                      src: _ctx.getCdnImageAddress(service.serviceIcon, `w_123,h_108/`),
                      alt: "Strategy & Consulting"
                    }, null, 8, _hoisted_17)
                  ]),
                  _createElementVNode("h4", null, _toDisplayString(_ctx.getTruncatedText(service.title, 50)), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.useStripHtml(_ctx.getTruncatedText(service.shortDescription, 150))), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "arrow-down-img" }, null, -1))
                ], 10, _hoisted_16)
              ]))
            }), 128))
          ])
        ])
      ]),
      (_ctx.selectedService)
        ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  src: _ctx.getCdnImageAddress(_ctx.selectedService.serviceImage, `w_563,h_457/`),
                  alt: _ctx.selectedService.title
                }, null, 8, _hoisted_22)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.selectedService.title), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.useStripHtml(_ctx.selectedService.shortDescription)), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.useStripHtml(_ctx.truncatedDescription)), 1)
                ]),
                (_ctx.shouldShowReadMore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDescription && _ctx.toggleDescription(...args))),
                        class: "read-more-btn"
                      }, _toDisplayString(_ctx.isDescriptionExpanded ? '<< Read Less' : 'Read More >>'), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog) => {
        return (_openBlock(), _createElementBlock("section", {
          class: "big-picture-fold",
          key: blog.slug
        }, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("img", {
                src: _ctx.getCdnImageAddress(blog.blogImage, `w_575,h_457/`),
                alt: ""
              }, null, 8, _hoisted_29)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.constants['FEATURED_BLOG_ARTICLE_TEXT']), 1),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("h5", null, _toDisplayString(blog.title), 1),
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.useStripHtml(_ctx.getBlogDescription(blog))), 1)
              ]),
              (_ctx.shouldShowBlogReadMore(blog))
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createVNode(_component_router_link, {
                      to: `/blogs/${blog.slug}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.constants['READ_MORE_LINK']) + " >>", 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_userFooter),
    _createVNode(_component_ChatbotPopup)
  ]))
}